import CustomCard from "../../blocks/Card/Card";
import { Empty } from "antd";

const ErrorTag = ({title, description}) => {
    return (
        <CustomCard title={title} className="title-2">
            <Empty description={description ? description : "Data Unavailable"} />
        </CustomCard>
    )
}

export default ErrorTag